import { Module } from './module.types';

export const defaultModuleData: Module = {
  title: '',
  description: '',
  summary: '',
  moduleURL: '',
  image: '',
  rooms: [],
  tags: [],
  prerequisites: [],
  nextSteps: [],
  difficultyLevel: 1,
  collaborator: [],
  ctf: false,
};
